module.exports = __webpack_public_path__ + "static/media/supply_image_1.50f30fff.jpg";